import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@constants/endpoints";

const unwrap = (res) => {
    const result = res.data || res;
    return result.data || result;
};

const useOverview = (brandId) => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });
    // The cache-busting re-read gets its own instance so it never flips the tab-level
    // spinner — the cards stay on screen while the refresh button spins.
    const { axiosInstance: refreshAxiosInstance, loading: refreshing } = useAxios({ base: "ops" });
    const [overview, setOverview] = useState(null);
    const [dashboard, setDashboard] = useState(null);

    useEffect(() => {
        const fetchOverview = async () => {
            const [accountRes, dashboardRes] = await Promise.all([
                axiosInstance.get(OPS_ENDPOINTS.BRAND(brandId)),
                // A failed dashboard shouldn't take the configuration card down with it.
                axiosInstance.get(OPS_ENDPOINTS.BRAND_DASHBOARD(brandId)).catch(() => null)
            ]);
            setOverview(unwrap(accountRes));
            setDashboard(dashboardRes ? unwrap(dashboardRes) : null);
        };
        fetchOverview();
    }, [brandId]); // eslint-disable-line react-hooks/exhaustive-deps

    const refresh = async () => {
        const res = await refreshAxiosInstance.get(OPS_ENDPOINTS.BRAND_DASHBOARD(brandId), { params: { refresh: true } });
        setDashboard(unwrap(res));
    };

    return {
        overview,
        stats           : dashboard?.stats || {},
        amounts         : dashboard?.amounts || [],
        activeDebitNotes: dashboard?.latest_active_debit_notes || [],
        generatedAt     : dashboard?.generated_at,
        loading,
        refreshing,
        refresh
    };
};

export default useOverview;
